type CheckCounts = { total: number; done: number; blockingPending: number }

// A hire can have more than one checklist, so its progress adds them up.
export function sumCheckCounts(checklists: { checkCounts: CheckCounts }[]): CheckCounts {
  return checklists.reduce<CheckCounts>(
    (sum, { checkCounts }) => ({
      total: sum.total + checkCounts.total,
      done: sum.done + checkCounts.done,
      blockingPending: sum.blockingPending + checkCounts.blockingPending,
    }),
    { total: 0, done: 0, blockingPending: 0 },
  )
}
